import { render } from "./LeadsStatus.vue?vue&type=template&id=6d4eaa96&scoped=true"
import script from "./LeadsStatus.vue?vue&type=script&lang=js"
export * from "./LeadsStatus.vue?vue&type=script&lang=js"

import "./LeadsStatus.vue?vue&type=style&index=0&id=6d4eaa96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4eaa96"]])

export default __exports__